<template>
  <div>
    <form
      name="checkout"
      class="checkout woocommerce-checkout"
      novalidate="novalidate"
      @submit.prevent
    >
      <div
        class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout"
        v-if="errors.length"
      >
        <ul class="woocommerce-error" role="alert">
          <li v-for="(error, i) in errors" v-html="error" :key="`err${i}`"></li>
        </ul>
      </div>
      <div v-if="cart.qty && showCheckout">
        <div class="col2-set" id="customer_details">
          <div class="col-1">
            <div class="woocommerce-billing-fields">
              <div class="h3">{{ $t('contactInformation') }}</div>
              <div class="woocommerce-billing-fields__field-wrapper">
                <p
                  class="form-row form-row-wide validate-required validate-required"
                  id="billing_first_name_field"
                  data-priority="10"
                >
                  <label for="billing_first_name" class="">
                    {{ $t('fullName') }}&nbsp;
                    <abbr class="required" title="обязательно">*</abbr>
                  </label>
                  <span class="woocommerce-input-wrapper">
                    <input
                      type="text"
                      class="input-text"
                      name="billing_first_name"
                      id="billing_first_name"
                      autocomplete="given-name"
                      :placeholder="$t('inputName')"
                      v-model="form.name"
                      ref="name"
                      @blur="$v.form.name.$touch()"
                      @input="onChangeName()"
                    />
                    <div
                      class="error"
                      v-if="$v.form.name.$dirty && !$v.form.name.required"
                    >
                      {{ $t('appealForm.emptyName') }}
                    </div>
                  </span>
                </p>
                <p
                  class="form-row form-row-wide validate-required validate-required validate-phone"
                  id="billing_phone_field"
                  data-priority="100"
                >
                  <label for="billing_phone" class="">
                    {{ $t('phone') }}&nbsp;
                    <abbr class="required" :title="$t('required')">*</abbr>
                  </label>
                  <span class="woocommerce-input-wrapper">
                    <VuePhoneNumberInput
                      default-country-code="UA"
                      :valid-color="'#ddd'"
                      :color="'#ddd'"
                      error-color="red"
                      :no-example="true"
                      :show-code-on-list="true"
                      name="billing_phone"
                      id="billing_phone"
                      ref="phone"
                      :placeholder="$t('yourPhone')"
                      v-model="form.phone"
                      @update="updatePhone"
                      @input="phoneMask()"
                    />
                    <div
                      class="error"
                      v-if="$v.form.phone.$dirty && !$v.form.phone.required"
                    >
                      {{ $t('appealForm.emptyPhone') }}
                    </div>
                    <div
                      class="error"
                      v-if="$v.form.phone.$dirty && !$v.form.phone.alpha"
                    >
                      {{ $t('appealForm.invalidPhone') }}
                    </div>
                  </span>
                </p>
                <p
                  class="form-row form-row-wide validate-required validate-required validate-email"
                  id="billing_email_field"
                  data-priority="100"
                >
                  <label for="billing_email" class="">
                    {{ $t('email') }}
                    <!-- <abbr class="required" :title="$t('required')">*</abbr> -->
                  </label>
                  <span class="woocommerce-input-wrapper">
                    <input
                      type="email"
                      class="input-text"
                      name="billing_email"
                      id="billing_email"
                      placeholder="user@gmail.com"
                      value=""
                      autocomplete="email"
                      ref="email"
                      v-model="form.email"
                      @blur="$v.form.email.$touch()"
                    />
                    <!-- <div
                      class="error"
                      v-if="$v.form.email.$dirty && !$v.form.email.required"
                    >
                      {{ $t('appealForm.emptyMail') }}
                    </div> -->
                    <div
                      class="error"
                      v-if="$v.form.email.$dirty && !$v.form.email.alpha"
                    >
                      {{ $t('appealForm.invalidMail') }}
                    </div>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-2 col2-comments" ref="deliveryTargetContainer">
            <div class="woocommerce-additional-fields">
              <div class="woocommerce-additional-fields__field-wrapper">
                <p class="form-row notes" id="order_comments_field">
                  <label for="order_comments" class="">
                    {{ $t('orderComment') }}
                    <span class="optional">({{ $t('notMandatory') }})</span>
                  </label>
                  <span class="woocommerce-input-wrapper">
                    <textarea
                      name="order_comments"
                      class="input-text"
                      id="order_comments"
                      :placeholder="$t('orderCommentPlaceholder')"
                      rows="2"
                      cols="7"
                      v-model="form.comment"
                    ></textarea>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="order_review" class="woocommerce-checkout-review-order">
          <div
            id="order_review_heading"
            class="h3"
            style="margin-top: 30px; clear: both"
          >
            {{ $t('delivery') }}
          </div>
          <div id="delivery" class="woocommerce-checkout-payment">
            <ul class="wc_payment_methods payment_methods methods">
              <li class="wc_payment_method">
                <input
                  id="delivery_method_pickup"
                  type="radio"
                  class="input-radio"
                  name="delivery_method"
                  v-model="deliveryMethod"
                  value="pickup"
                  :checked="deliveryMethod === 'pickup'"
                  @change="onChangeDelivery(false)"
                />
                <label for="delivery_method_pickup">
                  {{ $t('deliveryPickup') }}
                </label>
                <div
                  class="payment_box payment_method_pickup"
                  v-show="deliveryMethod === 'pickup'"
                >
                  <p
                    class="form-row address-field form-row-wide validate-required"
                    id="billing_address_1_field2"
                    data-priority="50"
                    ref="elCity"
                  >
                    <select v-model="pickupCity">
                      <option :value="null" selected>{{ $t('city_3') }}</option>
                      <!-- <option :value="$t('cities.vinn')">
                        {{ $t('cities.vinn') }}
                      </option> -->
                      <option :value="$t('cities.kyiv')">
                        {{ $t('cities.kyiv') }}
                      </option>
                      <!-- <option :value="$t('cities.odessa')">
                        {{ $t('cities.odessa') }}
                      </option> -->
                    </select>
                  </p>
                </div>
              </li>
              <li class="wc_payment_method">
                <input
                  id="delivery_method_adress"
                  type="radio"
                  class="input-radio"
                  name="delivery_method"
                  v-model="deliveryMethod"
                  value="adress"
                  :checked="deliveryMethod === 'adress'"
                  @change="onChangeDelivery(false)"
                />
                <label for="delivery_method_adress">
                  {{ $t('deliveryAdress') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="deliveryMethod === 'adress'"
                >
                  <p
                    class="form-row address-field form-row-wide validate-required"
                    id="billing_address_1_field2"
                    data-priority="50"
                    ref="elCity"
                  >
                    <label for="billing_address_1_2" class="">
                      {{ $t('city_2') }}&nbsp;
                      <abbr class="required" title="обязательно">*</abbr>
                    </label>
                    <span class="woocommerce-input-wrapper">
                      <input
                        type="text"
                        class="input-text"
                        v-model="billing_address_1_2"
                        name="billing_address_1_2"
                        id="billing_address_1_2"
                      />
                    </span>
                  </p>
                </div>
              </li>
              <li class="wc_payment_method">
                <input
                  id="delivery_method_np"
                  type="radio"
                  class="input-radio"
                  name="delivery_method"
                  v-model="deliveryMethod"
                  value="NP"
                  :checked="deliveryMethod === 'NP'"
                  @change="onChangeDelivery(true)"
                />
                <label for="delivery_method_np">
                  {{ $t('deliveryNP') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-if="showDeliveryCity"
                >
                  <p
                    class="form-row address-field form-row-wide validate-required"
                    id="billing_address_1_field"
                    data-priority="50"
                    ref="elCity"
                  >
                    <label for="billing_address_1" class="">
                      {{ $t('city') }}&nbsp;
                      <abbr class="required" title="обязательно">*</abbr>
                    </label>
                    <span class="woocommerce-input-wrapper">
                      <input
                        type="text"
                        class="input-text"
                        name="billing_address_1"
                        id="billing_address_1"
                        placeholder="г. Винница, Винницкая область"
                        autocomplete="address-line1"
                        data-placeholder="Город, населенный пункт, область"
                        v-model="deliveryCity"
                        @input="onTypeCity"
                      />
                      <!-- <div
                        class="error"
                        v-if="$v.deliveryCity.$dirty && !$v.deliveryCity.required"
                      >
                        {{ $t('emptyCity') }}
                      </div> -->
                    </span>
                    <input-dropdown
                      v-if="showDeliveryCityDropdown"
                      :items="delivery.cityRefs"
                      @onItemSelected="onDeliveryCitySelected"
                      id="deliveryCityDropdown"
                    />
                  </p>
                  <p
                    class="form-row address-field form-row-wide validate-required"
                    id="billing_address_2_field"
                    data-priority="50"
                    ref="elDepartment"
                    style="margin-top: 14px"
                  >
                    <label for="billing_address_2" class="">
                      {{ $t('department') }}&nbsp;
                      <abbr class="required" title="обязательно">*</abbr>
                    </label>
                    <span class="woocommerce-input-wrapper">
                      <input
                        type="text"
                        class="input-text"
                        name="billing_address_2"
                        id="billing_address_2"
                        placeholder="ул. Пирогова 132, кв.23"
                        autocomplete="address-line2"
                        :disabled="!showDeliveryDepartment"
                        data-placeholder="Номер дома и название улицы"
                        v-model="deliveryDepartment"
                        @input="onTypeDepartment"
                      />
                      <span class="tooltip-wrap">
                        <i class="fa fa-question"></i>
                        <span>{{ $t('warehouse.tip') }}</span>
                      </span>
                      <span class="tooltip-text">{{
                        $t('warehouse.msg')
                      }}</span>
                    </span>
                    <input-dropdown
                      v-if="showDeliveryDepartmentDropdown"
                      :items="delivery.departmentRefs"
                      :filter="deliveryDepartment"
                      @onItemSelected="onDeliveryDepartmentSelected"
                      id="deliveryDepartmentDropdown"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="h3" id="order_review_heading" style="margin-top: 30px">
            {{ $t('payment') }}
          </div>
          <div id="payment" class="woocommerce-checkout-payment">
            <ul class="wc_payment_methods payment_methods methods">
              <li
                v-if="isPaymentEnabled('platon')"
                class="wc_payment_method payment_method_mono"
              >
                <input
                  id="payment_method_pln"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Pln"
                  v-model="paymentMethod"
                />
                <label for="payment_method_pln"
                  ><span class="payment-icon"
                    ><img src="/img/vmc-payment.png"
                  /></span>
                  {{ $t('paymentPlaton') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Pln'"
                >
                  <p>{{ $t('paymentPlatonInfo') }}</p>
                  <!-- <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount2">
                    <option
                      :value="i"
                      v-for="i in ([].length = 10)"
                      :key="i"
                      v-show="i >= 3"
                      >{{ i }}</option
                    >
                  </select> -->
                  <!-- <br />
                  <p>
                    {{$t('monthPayment')}} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(Math.round(totalPriceWithFee / partsCount))
                      "
                    ></span>
                  </p> -->
                </div>
              </li>
              <li
                class="wc_payment_method payment_method_cod"
                v-show="deliveryMethod === 'adress'"
              >
                <input
                  id="payment_method_cod11"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Cash_ADR"
                  v-model="paymentMethod"
                />
                <label for="payment_method_cod11"
                  ><span class="payment-icon"
                    ><img src="/img/cash-payment.svg"
                  /></span>
                  {{ $t('paymentOnPickup2') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Cash_ADR'"
                >
                  <p>{{ $t('paymentOnPickupInfo2') }}</p>
                </div>
              </li>
              <li
                class="wc_payment_method payment_method_cod"
                v-show="deliveryMethod === 'NP'"
              >
                <input
                  id="payment_method_cod1"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Cash_NP"
                  v-model="paymentMethod"
                />
                <label for="payment_method_cod1"
                  ><span class="payment-icon"
                    ><img src="/img/cash-payment.svg"
                  /></span>
                  {{ $t('paymentOnPickup') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Cash_NP'"
                >
                  <p>{{ $t('paymentOnPickupInfo') }}</p>
                </div>
              </li>
              <li
                class="wc_payment_method payment_method_cod"
                v-show="deliveryMethod === 'pickup'"
              >
                <input
                  id="payment_method_cod"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Cash"
                  v-model="paymentMethod"
                />
                <label for="payment_method_cod"
                  ><span class="payment-icon"
                    ><img src="/img/cash-payment.svg"
                  /></span>
                  {{ $t('paymentOnPickupFromStore') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Cash'"
                >
                  <p>{{ $t('paymentOnPickupFromStoreInfo') }}</p>
                </div>
              </li>
              <li
                v-if="isPaymentEnabled('mono')"
                class="wc_payment_method payment_method_mono"
              >
                <input
                  id="payment_method_card"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Card"
                  v-model="paymentMethod"
                />
                <label for="payment_method_card"
                  ><span class="payment-icon"
                    ><img src="/img/tnfr-payment.svg"
                  /></span>
                  {{ $t('paymentOnCard') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Card'"
                >
                  <p>{{ $t('paymentOnCardInfo') }}</p>
                </div>
              </li>
              <!-- <li class="wc_payment_method payment_method_whitepay">
                <input
                  id="payment_method_whitepay"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Whitepay"
                  v-model="paymentMethod"
                />
                <label for="payment_method_whitepay"
                  ><span class="payment-icon"
                    ><img src="/img/whitepay.png"
                  /></span>
                  {{ $t('paymentWhitepay') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Whitepay'"
                >
                  <p>{{ $t('paymentWhitepayInfo') }}</p>
                </div>
              </li> -->
              <li class="wc_payment_method">
                <input
                  id="payment_method_paylate"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Paylate"
                  v-model="paymentMethod"
                />
                <label for="payment_method_paylate"
                  ><span class="payment-icon"
                    ><img src="/img/sign_color.png"
                  /></span>
                  {{ $t('paylateText') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Paylate'"
                >
                  <p>
                    <Paylate :product="cartItems[0]" />
                  </p>
                </div>
              </li>
              <li
                v-if="isPaymentEnabled('pb')"
                class="wc_payment_method payment_method_pb"
              >
                <input
                  id="payment_method_pb_pp"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="PB_PP"
                  v-model="paymentMethod"
                />
                <label for="payment_method_pb_pp"
                  ><span class="payment-icon"
                    ><img src="/img/op-logo.png"
                  /></span>
                  {{ $t('paymentPB') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'PB_PP'"
                >
                  <p>{{ $t('paymentPBInfo') }}</p>
                  <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount">
                    <option
                      :value="i"
                      v-for="i in ([].length = 25)"
                      :key="i"
                      v-show="i >= 2 && i <= 25"
                    >
                      {{ i }}
                    </option>
                  </select>
                  <br />
                  <p>
                    {{ $t('monthPayment') }} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(
                          Math.round(totalPriceWithFee / partsCount)
                        )
                      "
                    ></span>
                  </p>
                </div>
              </li>
              <li
                v-if="isPaymentEnabled('pb')"
                class="wc_payment_method payment_method_pb"
              >
                <input
                  id="payment_method_pb_ii"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="PB_II"
                  v-model="paymentMethod"
                />
                <label for="payment_method_pb_ii"
                  ><span class="payment-icon"
                    ><img src="/img/pb_quick2.png"
                  /></span>
                  {{ $t('paymentPB_II') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'PB_II'"
                >
                  <p>{{ $t('paymentPB_IIInfo') }}</p>
                  <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount1">
                    <option
                      :value="i"
                      v-for="i in ([].length = 24)"
                      :key="i"
                      v-show="i >= 3 && i <= 24"
                    >
                      {{ i }}
                    </option>
                  </select>
                  <br />
                  <p>
                    {{ $t('monthPayment') }} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(
                          Math.round(totalPriceWithFee / partsCount)
                        )
                      "
                    ></span>
                  </p>
                </div>
              </li>
              <li
                class="wc_payment_method payment_method_mono"
                v-show="paymentMethod === 'Mono'"
              >
                <input
                  id="payment_method_mono"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Mono"
                  disabled
                  v-model="paymentMethod"
                />
                <label for="payment_method_mono"
                  ><span class="payment-icon"
                    ><img src="/img/mono-payment.png"
                  /></span>
                  {{ $t('paymentMono') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Mono'"
                >
                  <p>{{ $t('paymentMonoInfo') }}</p>
                  <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount2" disabled>
                    <option :value="i" v-for="i in [3, 6, 9]" :key="i">
                      {{ i }}
                    </option>
                  </select>
                  <br />
                  <p>
                    {{ $t('monthPayment') }} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(
                          Math.round(totalPriceWithFee / partsCount)
                        )
                      "
                    ></span>
                  </p>
                  <p v-if="partsCount >= 3">
                    * {{ $t('price') }} ({{ monoOrder }}) - ₴&nbsp;
                    <span
                      v-html="$h.formatPrice(Math.round(totalPriceWithFee))"
                    ></span>
                  </p>
                </div>
              </li>
              <li class="wc_payment_method payment_method_abank">
                <input
                  id="payment_method_abank"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="ABank"
                  v-model="paymentMethod"
                />
                <label for="payment_method_abank"
                  ><span class="payment-icon"
                    ><img src="/img/abank-logo.png"
                  /></span>
                  {{ $t('paymentABank') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'ABank'"
                >
                  <p>{{ $t('paymentABankInfo') }}</p>
                  <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount3">
                    <option
                      :value="i"
                      v-for="i in ([].length = 25)"
                      :key="i"
                      v-show="i >= 2 && i <= 25"
                    >
                      {{ i }}
                    </option>
                  </select>
                  <br />
                  <p>
                    {{ $t('monthPayment') }} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(
                          Math.round(totalPriceWithFee / partsCount)
                        )
                      "
                    ></span>
                  </p>
                </div>
              </li>
              <li class="wc_payment_method payment_method_abank2">
                <input
                  id="payment_method_abank2"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="ABank2"
                  v-model="paymentMethod"
                />
                <label for="payment_method_abank2"
                  ><span class="payment-icon"
                    ><img src="/img/abank-logo.png"
                  /></span>
                  {{ $t('paymentABank2') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'ABank2'"
                >
                  <p>{{ $t('paymentABankInfo2') }}</p>
                  <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount-ABank2">
                    <option
                      :value="i"
                      v-for="i in ([].length = 24)"
                      :key="i"
                      v-show="i >= 1 && i <= 24"
                    >
                      {{ i }}
                    </option>
                  </select>
                  <br />
                  <p>
                    {{ $t('monthPayment') }} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(
                          Math.round(totalPriceWithFee / partsCount)
                        )
                      "
                    ></span>
                  </p>
                </div>
              </li>
              <li class="wc_payment_method payment_method_globus">
                <input
                  id="payment_method_globus"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Globus"
                  @change="onCheckoutGlobusPaymentMethodChange"
                  v-model="paymentMethod"
                />
                <label for="payment_method_globus"
                  ><span class="payment-icon"
                    ><img src="/img/globus-logo.png"
                  /></span>
                  {{ $t('paymentGlobus') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Globus'"
                >
                  <p>{{ $t('paymentGlobusInfo') }}</p>
                  <br />
                  <p>{{ $t('partsCountBank') }}</p>
                  <select v-model="partsCount" id="partsCount3">
                    <option :value="i" v-for="i in globusParts" :key="i">
                      {{ i }}
                    </option>
                  </select>
                  <br />
                  <p>
                    {{ $t('monthPayment') }} - ₴&nbsp;
                    <span
                      v-html="
                        $h.formatPrice(
                          Math.round(totalPriceWithFee / partsCount)
                        )
                      "
                    ></span>
                  </p>
                </div>
              </li>
              <li class="wc_payment_method payment_method_sense">
                <input
                  id="payment_method_sense"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Sense"
                  v-model="paymentMethod"
                />
                <label for="payment_method_sense"
                  ><span class="payment-icon"
                    ><img src="/img/sense-logo.png"
                  /></span>
                  {{ $t('paymentSense') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Sense'"
                >
                  <SenseCreditCheckout :products="cartItems" :form="form" />
                </div>
              </li>
              <!-- <li
                v-if="isPaymentEnabled('ukr')"
                class="wc_payment_method payment_method_ukr"
              >
                <input
                  id="payment_method_ukr"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="Ukr"
                  v-model="paymentMethod"
                />
                <label for="payment_method_ukr"
                  ><span class="payment-icon"
                    ><img src="/img/ukr-payment.svg"
                  /></span>
                  {{ $t('paymentUkr') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'Ukr'"
                >
                  <p>{{ $t('paymentUkrInfo') }}</p>
                </div>
              </li> -->
              <li class="wc_payment_method payment_method_pumb">
                <input
                  id="payment_method_pumb"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="pumb"
                  v-model="paymentMethod"
                />
                <label for="payment_method_pumb"
                  ><span class="payment-icon"><img src="/img/pumb.png" /></span>
                  {{ $t('paymentPumb') }}
                </label>
                <div
                  class="payment_box payment_method_cod"
                  v-show="paymentMethod === 'pumb'"
                >
                  <p>{{ $t('paymentPumbInfo') }}</p>
                </div>
              </li>
              <!-- <li
                      v-if="isPaymentEnabled('fondy')"
                      class="wc_payment_method payment_method_fondy"
              >
                <input
                        id="payment_method_fondy"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="Online"
                        v-model="paymentMethod"
                />
                <label for="payment_method_fondy"><span class="payment-icon"><img src="/img/card-payment.svg"></span>
                  {{ $t('paymentFondy') }}
                </label>
                <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'Online'"
                >
                  <p>{{ $t('paymentFondyInfo') }}</p>
                </div>
              </li>-->
              <li class="wc_payment_method">
                <input
                  id="payment_method_slonCredit"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="SlonCredit"
                  v-model="paymentMethod"
                />
                <label for="payment_method_slonCredit">
                  <span class="payment-icon">
                    <img src="/img/sloncredit-logo.png" />
                  </span>
                  {{ $t('paymentSlonCredit') }}
                </label>
                <div
                  class="payment_box payment_method_slonCredit"
                  v-show="paymentMethod === 'SlonCredit'"
                >
                  <div class="slonCredit-iframe-wrapper">
                    <iframe
                      style="height: 100%; width: 100%"
                      frameborder="0"
                      :src="slonCreditSrc"
                    ></iframe>
                  </div>
                </div>
              </li>
              <li class="wc_payment_method">
                <input
                  id="payment_method_novaPoshta"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="novaPoshta"
                  v-model="paymentMethod"
                />
                <label for="payment_method_novaPoshta">
                  <span class="payment-icon">
                    <img src="/img/mark69.png" />
                  </span>
                  {{ $t('paymentNovaPoshta') }}
                </label>
                <div
                  class="payment_box payment_method_novaPoshta"
                  v-show="paymentMethod === 'novaPoshta'"
                >
                  <p>{{ $t('paymentNovaPoshtaInfo') }}</p>
                </div>
              </li>
              <li class="wc_payment_method">
                <input
                  id="payment_method_ideaBank"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="IdeaBank"
                  v-model="paymentMethod"
                />
                <label for="payment_method_ideaBank">
                  <span class="payment-icon">
                    <img src="/img/idea-bank.png" />
                  </span>
                  {{ $t('paymentIdeaBank') }}
                </label>
                <div
                  class="payment_box payment_method_ideaBank"
                  v-show="paymentMethod === 'IdeaBank'"
                >
                  <p>{{ $t('ideaBankPoshtaInfo') }}</p>
                </div>
              </li>
              <li class="wc_payment_method payment_method_otp">
                <input
                  id="payment_method_otp"
                  type="radio"
                  class="input-radio"
                  name="payment_method"
                  value="otp"
                  v-model="paymentMethod"
                />
                <label for="payment_method_otp">
                  <span class="payment-icon">
                    <img src="/img/otp_bank_logo.png" />
                  </span>
                  {{ $t('paymentOTP') }}
                </label>
                <div
                  class="payment_box payment_method_otp"
                  v-show="paymentMethod === 'otp'"
                >
                  <OTPCreditCheckout :products="cartItems" />
                </div>
              </li>
            </ul>
            <p :class="`pay_parts_info ${isOpen ? 'opened' : 'closed'}`">
              {{ $t('payPartsInfo') }}
            </p>
            <div
              :class="`checkout_additional ${isOpen ? 'opened' : 'closed'}`"
              @click.stop.prevent="onToggle()"
            >
              <span
                :class="`seasidetms_theme_icon_slide_${
                  isOpen ? 'top' : 'bottom'
                }`"
              ></span>
            </div>
          </div>
          <div class="h3" id="order_review_heading" style="margin-top: 30px">
            {{ $t('yourOrder') }}
          </div>
          <table
            class="shop_table woocommerce-checkout-review-order-table"
            style="padding: 0"
          >
            <thead>
              <tr>
                <th class="product-name">{{ $t('product') }}</th>
                <th class="product-total">{{ $t('subtotal') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="cart_item"
                v-for="(item, idx) in cartItems"
                :key="`item_${idx}`"
              >
                <td class="product-name">
                  {{ item.name }}&nbsp;
                  <strong class="product-quantity">× {{ item.qty }}</strong>
                </td>
                <td class="product-total">
                  <span
                    v-if="item.isWarranty"
                    class="woocommerce-waranty-amount"
                  >
                    <span
                      style="margin-left: 0px !important; white-space: nowrap"
                      v-html="$h.formatPrice(productPrice(item))"
                    ></span
                    >грн
                  </span>
                  <span
                    v-if="!item.isWarranty"
                    style="margin-left: 0px; white-space: nowrap"
                    class="price-ukr"
                  >
                    <span v-html="$h.formatPrice(productPrice(item))"></span>грн
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="cart-subtotal">
                <th>{{ $t('totalPrice') }}</th>
                <td></td>
              </tr>
              <tr class="order-total">
                <th>{{ $t('subtotal') }}</th>
                <td>
                  <span
                    style="margin-left: 0px; white-space: nowrap"
                    class="price-ukr"
                  >
                    <span v-html="$h.formatPrice(totalPriceWithFee)"></span>грн
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
          <div
            class="woocommerce-checkout-payment"
            style="padding: 0 30px 30px 30px; margin-top: 30px"
          >
            <div class="form-row place-order">
              <div class="woocommerce-terms-and-conditions-wrapper">
                <div class="woocommerce-privacy-policy-text">
                  <p>
                    {{ $t('checkoutPolicyInfo') }}
                    <router-link
                      :to="
                        lang
                          ? '/' + lang + '/privacy-policy'
                          : '/privacy-policy'
                      "
                      target="_blank"
                    >
                      {{ $t('checkoutPolicyLink') }}
                    </router-link>
                  </p>
                </div>
                <div
                  class="woocommerce-terms-and-conditions"
                  style="display: none; max-height: 200px; overflow: auto"
                >
                  <div
                    id="seasidetms_row_x74ye23rz"
                    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
                  >
                    <div class="seasidetms_row_outer_parent">
                      <div class="seasidetms_row_outer">
                        <div class="seasidetms_row_inner">
                          <div class="seasidetms_row_margin">
                            <div
                              id="seasidetms_column_ckpgkqdgdw"
                              class="seasidetms_column one_first"
                            >
                              <div class="seasidetms_column_inner">
                                <div class="seasidetms_text">
                                  {{ conditionsContent }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="form-row validate-required">
                  <label
                    class="woocommerce-form__label woocommerce-form__label-for-checkbox checkbox"
                  >
                    <input
                      type="checkbox"
                      :checked="form.terms"
                      class="woocommerce-form__input woocommerce-form__input-checkbox input-checkbox"
                      name="terms"
                      id="terms"
                      ref="terms"
                      @change="onTermsChange"
                      v-model="form.terms"
                    />
                    <span
                      class="woocommerce-terms-and-conditions-checkbox-text"
                    >
                      {{ $t('checkoutConditionsInfo') }}
                      <router-link
                        :to="
                          lang
                            ? '/' + lang + '/terms-and-conditions'
                            : '/terms-and-conditions'
                        "
                        class="woocommerce-terms-and-conditions-link"
                        target="_blank"
                      >
                        {{ $t('checkoutConditionsLink') }}
                      </router-link>
                    </span>
                    &nbsp;<span class="required">*</span>
                  </label>
                  <input type="hidden" name="terms-field" value="1" />
                </p>
              </div>
              <div class="error terms-error" v-if="termsError">
                {{ $t('defaultRequiredErrorMsg') }}
              </div>
              <button
                type="button"
                class="button alt"
                name="woocommerce_checkout_place_order"
                id="place_order"
                :disabled="sent || submitting"
                :value="$t('confirmOrder')"
                @click="onSumbit"
              >
                {{ $t('confirmOrder') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!cart.qty">
        <div class="h3">{{ $t('cartEmpty') }}</div>
        <p class="return-to-shop">
          <router-link class="button wc-backward" :to="lang ? '/' + lang : '/'">
            {{ $t('backToShop') }}
          </router-link>
        </p>
      </div>
      <div id="fondy"></div>
    </form>
    <form
      action="https://secure.platononline.com/payment/auth"
      method="post"
      id="form_submit"
    >
      <input type="hidden" name="payment" :value="submitForm.payment" />
      <input type="hidden" name="key" :value="submitForm.key" />
      <input type="hidden" name="url" :value="submitForm.url" />
      <input type="hidden" name="data" :value="submitForm.data" />
      <input type="hidden" name="req_token" :value="submitForm.req_token" />
      <input type="hidden" name="sign" :value="submitForm.sign" />
      <input type="hidden" name="order" :value="submitForm.order" />
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, sameAs, helpers } from 'vuelidate/lib/validators'
import { debounce } from 'debounce'
import { setTimeout } from 'timers'
import CryptoJS from 'crypto-js'
import CartMixin from '@/components/cart/CartMixin'
import InputDropdown from '@/components/order/InputDropdown'
import { v4 as uuidv4 } from 'uuid'
import VuePhoneNumberInput from 'vue-phone-number-input'
import Paylate from '@/components/product/Paylate'
import GlobusMixin from '@/components/product/GlobusMixin'
import OTPCreditCheckout from '@/components/credits/OTPCreditCheckout.vue'
import SenseCreditCheckout from '@/components/credits/SenseCreditCheckout.vue'

const additionalRate2pc = 0.02
const additionalRate3pc = 0.03
const additionalRate5pc = 0.05

export default {
  name: 'Checkout',
  components: {
    InputDropdown,
    VuePhoneNumberInput,
    Paylate,
    OTPCreditCheckout,
    SenseCreditCheckout,
  },
  mixins: [CartMixin, validationMixin, GlobusMixin],
  data() {
    return {
      errors: [],
      pickupCity: null,
      phoneInternational: '',
      termsError: false,
      form: {
        name: '',
        phone: '',
        email: '',
        comment: '',
        terms: false,
      },
      submitForm: {
        payment: '',
        key: '',
        url: '',
        data: '',
        req_token: '',
        sign: '',
        order: '',
      },
      isOpen: false,
      billing_address_1_2: '',
      deliveryMethod: 'pickup',
      deliveryCity: '',
      deliveryDepartment: '',
      showCheckout: true,
      showDeliveryCity: false,
      showDeliveryCityDropdown: false,
      showDeliveryDepartment: false,
      showDeliveryDepartmentDropdown: false,
      deliveryPayment: 0,
      paymentMethod: 'Pln',
      partsCount: 3,
      sent: false,
      submitStatus: null,
      pbRates: [
        {
          parts: 2,
          value: 0.015 + additionalRate2pc,
        },
        {
          parts: 3,
          value: 0.017 + additionalRate2pc,
        },
        {
          parts: 4,
          value: 0.028 + additionalRate2pc,
        },
        {
          parts: 5,
          value: 0.045 + additionalRate2pc,
        },
        {
          parts: 6,
          value: 0.057 + additionalRate2pc,
        },
        {
          parts: 7,
          value: 0.069 + additionalRate3pc,
        },
        {
          parts: 8,
          value: 0.08 + additionalRate3pc,
        },
        {
          parts: 9,
          value: 0.091 + additionalRate3pc,
        },
        {
          parts: 10,
          value: 0.104 + additionalRate3pc,
        },
        {
          parts: 11,
          value: 0.117 + additionalRate5pc,
        },
        {
          parts: 12,
          value: 0.129 + additionalRate5pc,
        },
        {
          parts: 13,
          value: 0.14 + additionalRate5pc + 0.03,
        },
        {
          parts: 14,
          value: 0.151 + additionalRate5pc + 0.03,
        },
        {
          parts: 15,
          value: 0.162 + additionalRate5pc + 0.03,
        },
        {
          parts: 16,
          value: 0.173 + additionalRate5pc + 0.06,
        },
        {
          parts: 17,
          value: 0.183 + additionalRate5pc + 0.06,
        },
        {
          parts: 18,
          value: 0.194 + additionalRate5pc + 0.1,
        },
        {
          parts: 19,
          value: 0.204 + additionalRate5pc + 0.1,
        },
        {
          parts: 20,
          value: 0.215 + additionalRate5pc + 0.1,
        },
        {
          parts: 21,
          value: 0.225 + additionalRate5pc + 0.1,
        },
        {
          parts: 22,
          value: 0.235 + additionalRate5pc + 0.1,
        },
        {
          parts: 23,
          value: 0.245 + additionalRate5pc + 0.1,
        },
        {
          parts: 24,
          value: 0.255 + additionalRate5pc + 0.1,
        },
        {
          parts: 25,
          value: 0.265 + additionalRate5pc + 0.1,
        },
      ],
      pbIIRates: [
        {
          parts: 3,
          value: 0.039,
        },
        {
          parts: 4,
          value: 0.039,
        },
        {
          parts: 5,
          value: 0.039,
        },
        {
          parts: 6,
          value: 0.039,
        },
        {
          parts: 7,
          value: 0.039,
        },
        {
          parts: 8,
          value: 0.039,
        },
        {
          parts: 9,
          value: 0.039,
        },
        {
          parts: 10,
          value: 0.039,
        },
        {
          parts: 11,
          value: 0.049,
        },
        {
          parts: 12,
          value: 0.049,
        },
        {
          parts: 13,
          value: 0.049,
        },
        {
          parts: 14,
          value: 0.049,
        },
        {
          parts: 15,
          value: 0.049,
        },
        {
          parts: 16,
          value: 0.049,
        },
        {
          parts: 17,
          value: 0.049,
        },
        {
          parts: 18,
          value: 0.049,
        },
        {
          parts: 19,
          value: 0.049,
        },
        {
          parts: 20,
          value: 0.049,
        },
        {
          parts: 21,
          value: 0.049,
        },
        {
          parts: 22,
          value: 0.049,
        },
        {
          parts: 23,
          value: 0.049,
        },
        {
          parts: 24,
          value: 0.049,
        },
      ],
      monoRates: [
        {
          parts: 3,
          value: 0,
        },
        {
          parts: 4,
          value: 0,
        },
        {
          parts: 5,
          value: 0,
        },
        {
          parts: 6,
          value: 0,
        },
        {
          parts: 7,
          value: 0,
        },
        {
          parts: 8,
          value: 0,
        },
        {
          parts: 9,
          value: 0,
        },
        {
          parts: 10,
          value: 0,
        },
        {
          parts: 11,
          value: 0,
        },
        {
          parts: 12,
          value: 0,
        },
        {
          parts: 13,
          value: 0,
        },
        {
          parts: 14,
          value: 0,
        },
        {
          parts: 15,
          value: 0,
        },
        {
          parts: 16,
          value: 0,
        },
        {
          parts: 17,
          value: 0,
        },
        {
          parts: 18,
          value: 0,
        },
        {
          parts: 19,
          value: 0,
        },
        {
          parts: 20,
          value: 0,
        },
        {
          parts: 21,
          value: 0,
        },
        {
          parts: 22,
          value: 0,
        },
        {
          parts: 23,
          value: 0,
        },
        {
          parts: 24,
          value: 0,
        },
      ],
      aBankRates: [
        {
          parts: 2,
          value: 0.03 + additionalRate2pc,
        },
        {
          parts: 3,
          value: 0.033 + additionalRate2pc,
        },
        {
          parts: 4,
          value: 0.045 + additionalRate2pc,
        },
        {
          parts: 5,
          value: 0.06 + additionalRate2pc,
        },
        {
          parts: 6,
          value: 0.075 + additionalRate2pc,
        },
        {
          parts: 7,
          value: 0.083 + additionalRate3pc,
        },
        {
          parts: 8,
          value: 0.095 + additionalRate3pc,
        },
        {
          parts: 9,
          value: 0.108 + additionalRate3pc,
        },
        {
          parts: 10,
          value: 0.12 + additionalRate3pc,
        },
        {
          parts: 11,
          value: 0.132 + additionalRate5pc,
        },
        {
          parts: 12,
          value: 0.143 + additionalRate5pc,
        },
        {
          parts: 13,
          value: 0.155 + additionalRate5pc + 0.03,
        },
        {
          parts: 14,
          value: 0.166 + additionalRate5pc + 0.03,
        },
        {
          parts: 15,
          value: 0.177 + additionalRate5pc + 0.03,
        },
        {
          parts: 16,
          value: 0.188 + additionalRate5pc + 0.06,
        },
        {
          parts: 17,
          value: 0.198 + additionalRate5pc + 0.06,
        },
        {
          parts: 18,
          value: 0.209 + additionalRate5pc + 0.1,
        },
        {
          parts: 19,
          value: 0.219 + additionalRate5pc + 0.1,
        },
        {
          parts: 20,
          value: 0.23 + additionalRate5pc + 0.1,
        },
        {
          parts: 21,
          value: 0.24 + additionalRate5pc + 0.1,
        },
        {
          parts: 22,
          value: 0.249 + additionalRate5pc + 0.1,
        },
        {
          parts: 23,
          value: 0.259 + additionalRate5pc + 0.1,
        },
        {
          parts: 24,
          value: 0.268 + additionalRate5pc + 0.1,
        },
        {
          parts: 25,
          value: 0.278 + additionalRate5pc + 0.1,
        },
      ],
      lang: '',
      submitting: false,
    }
  },
  computed: {
    warranties() {
      return this.categories.reduce(
        (list, item) => list.concat(item.warranty),
        []
      )
    },
    warrantiesMapping() {
      return Object.fromEntries(this.warranties.map((item) => [item._id, item]))
    },
    monoOrder() {
      const itemsNames = this.cartItems.map(({ name }) => name)
      return itemsNames.join(' + ')
    },
    slonCreditSrc() {
      const { name, price, img, link, qty } = this.cartItems[0]
      const partnerId = process.env.VUE_APP_SLONCREDIT_PARTNER_ID
      const { origin } = document.location
      const imageSrc = `${origin}/img${img}`
      const productUrl = `${origin}${link}`
      return `https://api.sloncredit.com.ua/pos/iframe?c=${partnerId}&n=${name}&q=${qty}&p=${price}&pu=${productUrl}&i=${imageSrc}`
    },
    conditionsContent() {
      const data = require('@/assets/res/checkoutConditions_ru.htm').default
      return data
    },
    totalPrice() {
      let wPrice = 0
      this.cart.items.forEach((item) => {
        if (item.warranty) {
          wPrice += item.warranty
            .map((v) => +v.split(';')[2])
            .reduce((a, b) => a + b, 0)
        }
      })
      return this.cart.price + wPrice
    },
    totalPriceUsdWithFee() {
      if (this.paymentMethod === 'Online') {
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * 0.027)
      } else if (this.paymentMethod === 'PB_PP') {
        const rate = this.pbRates.filter((r) => r.parts === this.partsCount)[0]
          .value
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * rate)
      } else if (this.paymentMethod === 'PB_II') {
        const rate = this.pbIIRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * rate)
      } else if (this.paymentMethod === 'Mono') {
        const rate = this.monoRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * rate)
      } else if (this.paymentMethod === 'Globus') {
        const rate = this.globusRates.filter((r) => r.parts === this.partsCount)
        const rateValue =
          rate && rate.length ? rate[0].value : this.globusRates[0].value
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * rateValue)
      } else if (this.paymentMethod === 'ABank') {
        const rate = this.aBankRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * rate)
      } else if (this.paymentMethod === 'ABank2') {
        // const rate = 0.03 + 0.019 * this.partsCount
        const rate = 0.03
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * rate)
      } else if (this.paymentMethod === 'Pln') {
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * 0.03)
      } else if (this.paymentMethod === 'Whitepay') {
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * 0.01)
      }
      return this.cart.priceUsd
    },
    totalPriceWithFee() {
      let wPrice = 0
      //console.log(this.partsCount)
      this.cart.items.forEach((item) => {
        if (item.warranty) {
          wPrice += item.warranty
            .map((v) => +v.split(';')[2])
            .reduce((a, b) => a + b, 0)
        }
      })
      if (this.paymentMethod === 'Online') {
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * 0.027 + wPrice * 0.027)
        )
      } else if (this.paymentMethod === 'PB_PP') {
        const rate = this.pbRates.filter((r) => r.parts === this.partsCount)[0]
          .value
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * rate + wPrice * rate)
        )
      } else if (this.paymentMethod === 'PB_II') {
        const rate = this.pbIIRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * rate + wPrice * rate)
        )
      } else if (this.paymentMethod === 'Mono') {
        const rate = this.monoRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * rate + wPrice * rate)
        )
      } else if (this.paymentMethod === 'Globus') {
        const rate = this.globusRates.filter((r) => r.parts === this.partsCount)
        const rateValue =
          rate && rate.length ? rate[0].value : this.globusRates[0].value
        return Math.round(
          this.cart.price +
            wPrice +
            (this.cart.price * rateValue + wPrice * rateValue)
        )
      } else if (this.paymentMethod === 'ABank') {
        const rate = this.aBankRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * rate + wPrice * rate)
        )
      } else if (this.paymentMethod === 'ABank2') {
        // const rate = 0.03 + 0.019 * this.partsCount
        const rate = 0.03
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * rate + wPrice * rate)
        )
      } else if (this.paymentMethod === 'Pln') {
        return Math.round(
          this.cart.price + wPrice + (this.cart.price * 0.03 + wPrice * 0.03)
        )
      } else if (this.paymentMethod === 'Whitepay') {
        return Math.round(this.cart.priceUsd + this.cart.priceUsd * 0.01)
      } else {
        return this.cart.price + wPrice
      }
    },
    orderId() {
      return this.order.order.order_id
    },
    //[{ item: _id, count: qty, price: Number, }],
    orderProducts() {
      let products = []
      this.cart.items.forEach((item) => {
        products.push({
          item: item.id,
          id: item.did,
          name: item.name,
          count: item.qty,
          kitDisc: item.kitDisc,
          price: Math.round(this.productPriceWithFee(item)),
          priceUsd: this.productPriceUsd(item),
        })
        if (
          Array.isArray(item.profitableKit) &&
          item.profitableKit.length >= 1
        ) {
          console.log(item.kitDisc, 'orderProducts')
          let p
          item.profitableKit.forEach((i) => {
            p = this.makeProfitItem(i, item.qty, item.kitDisc)
            products.push({
              name: p.name,
              count: item.qty,
              kitDisc: item.kitDisc,
              price: Math.round(this.productPriceWithFee(p)),
              priceUsd: p.priceUsd,
            })
          })
          // let p = this.makeProfitItem(
          //   item.profitableKit[0],
          //   item.qty,
          //   item.kitDisc
          // )
          // products.push({
          //   name: p.name,
          //   count: item.qty,
          //   kitDisc: item.kitDisc,
          //   price: Math.round(this.productPriceWithFee(p)),
          //   priceUsd: p.priceUsd,
          // })
          // p = this.makeProfitItem(item.profitableKit[1], item.qty, item.kitDisc)
          // products.push({
          //   name: p.name,
          //   count: item.qty,
          //   kitDisc: item.kitDisc,
          //   price: Math.round(this.productPriceWithFee(p)),
          //   priceUsd: p.priceUsd,
          // })
        }
      })
      return products
    },
    ...mapState(['delivery', 'checkout', 'payment', 'order']),
  },
  methods: {
    onTermsChange() {
      this.termsError = false
    },
    onToggle() {
      this.isOpen = !this.isOpen
    },
    isPaymentEnabled() {
      // let id = `${v}`.toLowerCase()
      // return !!this.$store.state.payments[id]
      return true
    },
    productPrice(product) {
      return product.newPrice ? product.newPrice : product.price
    },
    productPriceWithFeePrice(price) {
      //console.log(this.paymentMethod)
      if (this.paymentMethod === 'Online') {
        return price + price * 0.027
      } else if (this.paymentMethod === 'PB_PP') {
        const rate = this.pbRates.filter((r) => r.parts === this.partsCount)[0]
          .value
        return price + price * rate
      } else if (this.paymentMethod === 'PB_II') {
        const rate = this.pbIIRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return price + price * rate
      } else if (this.paymentMethod === 'Mono') {
        const rate = this.monoRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        //console.log(this.partsCount)
        return price + price * rate
      } else if (this.paymentMethod === 'Globus') {
        const rate = this.globusRates.filter((r) => r.parts === this.partsCount)
        const rateValue =
          rate && rate.length ? rate[0].value : this.globusRates[0].value
        //console.log(this.partsCount)
        return price + price * rateValue
      } else if (this.paymentMethod === 'ABank') {
        const rate = this.aBankRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        //console.log(this.partsCount)
        return price + price * rate
      } else if (this.paymentMethod === 'ABank2') {
        // const rate = 0.03 + 0.019 * this.partsCount
        const rate = 0.03
        //console.log(this.partsCount)
        return price + price * rate
      } else {
        return price
      }
    },
    productPriceWithFee(product) {
      //console.log(this.paymentMethod)
      // console.log(this.partsCount)
      if (this.paymentMethod === 'Online') {
        return product.newPrice
          ? product.newPrice + product.newPrice * 0.027
          : product.price + product.price * 0.027
      } else if (this.paymentMethod === 'PB_PP') {
        const rate = this.pbRates.filter((r) => r.parts === this.partsCount)[0]
          .value
        return product.newPrice
          ? product.newPrice + product.newPrice * rate
          : product.price + product.price * rate
      } else if (this.paymentMethod === 'PB_II') {
        const rate = this.pbIIRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return product.newPrice
          ? product.newPrice + product.newPrice * rate
          : product.price + product.price * rate
      } else if (this.paymentMethod === 'Mono') {
        const rate = this.monoRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return product.newPrice
          ? product.newPrice + product.newPrice * rate
          : product.price + product.price * rate
      } else if (this.paymentMethod === 'Globus') {
        const rate = this.globusRates.filter((r) => r.parts === this.partsCount)
        const rateValue =
          rate && rate.length ? rate[0].value : this.globusRates[0].value
        return product.newPrice
          ? product.newPrice + product.newPrice * rateValue
          : product.price + product.price * rateValue
      } else if (this.paymentMethod === 'ABank') {
        const rate = this.aBankRates.filter(
          (r) => r.parts === this.partsCount
        )[0].value
        return product.newPrice
          ? product.newPrice + product.newPrice * rate
          : product.price + product.price * rate
      } else if (this.paymentMethod === 'ABank2') {
        // const rate = 0.03 + 0.019 * this.partsCount
        const rate = 0.03
        return product.newPrice
          ? product.newPrice + product.newPrice * rate
          : product.price + product.price * rate
      } else {
        return product.newPrice ? product.newPrice : product.price
      }
    },
    productPriceUsd(product) {
      return product.newPriceUsd ? product.newPriceUsd : product.priceUsd
    },
    scrollToField(name) {
      const el = this.$refs[name]
      if (
        el.$refs &&
        el.$refs.PhoneNumberInput &&
        el.$refs.PhoneNumberInput.$refs &&
        el.$refs.PhoneNumberInput.$refs['InputTel']
      ) {
        el.$refs.PhoneNumberInput.$refs['InputTel'].focus()
      } else if (name === 'terms') {
        this.termsError = true
      } else {
        el.focus()
      }
    },
    scrollToInvalid() {
      const fieldsOrder = ['name', 'phone', 'email', 'terms']

      for (const field of fieldsOrder) {
        if (this.$v.form[field] && this.$v.form[field].$invalid) {
          this.scrollToField(field)
          break
        }
      }
    },
    onSumbit() {
      if (this.$v.$invalid) {
        this.scrollToInvalid()
        return
      }

      // console.log('*PAYMENT_METHOD', this.payment.method)
      // console.log('*[submitOrder]', this.form)

      this.submitting = true

      let pickupCity = this.pickupCity
      let name = this.form.name
      let phone = this.phoneInternational
      let email = this.form.email
      let orderComment = this.form.comment
      let adresss = this.billing_address_1_2
      let description = ''
      let warranty = []
      let warranty2 = []
      const products = this.orderProducts
      this.cart.items.forEach((item, i) => {
        if (i > 0) description += '; '
        description += `${item.name} x ${item.qty}`
        item.warranty.forEach((w) => {
          const p = w.split(';')
          warranty.push(p[0])
          warranty2.push(p[2])
          description += ` ${p[1]} `
        })
        if (item.profitableKit && item.profitableKit.length) {
          item.profitableKit.forEach((p) => {
            description += `${p.name_ru} x 1 `
          })
        }
      })
      let address = null
      if (this.deliveryCity) {
        address = {
          city: this.delivery.cityId || null,
          warehouse: this.delivery.departmentId || null,
          cityName: this.deliveryCity,
          warehouseName: this.deliveryDepartment || null,
        }
      }
      //let deliveryMethod = this.delivery.method
      let payment = {
        method: this.paymentMethod, // Online/Cash/Cash_NP/PB_PP/PB_II/Mono
        // status: '',
        // total: this.cart.price,
        total: this.totalPrice,
        totalWithFee: this.totalPriceWithFee,
        totalUsd: this.cart.priceUsd,
      }
      // if (payment.method === 'Cash') payment.method = null
      if (payment.method === 'Cash') payment.method = '1'
      if (payment.method === 'Cash_NP') payment.method = '2'
      if (adresss) {
        orderComment += '\nАдресс доставки: ' + adresss
      }
      let order = {
        name,
        phone,
        email,
        orderComment,
        products,
        warranty, // [_id]
        description, // concat warranty names
        address,
        deliveryMethod: this.deliveryMethod,
        payment,
        pickupCity,
      }
      console.log('*[ORDER]', this.$h.dumpObj(order))
      // console.log('******', this.partsCount)

      // console.log('*order', order)
      this.submitOrder(order)
        .then((res) => {
          try {
            console.log(res + ' line 1029')
            this.$store.commit('setPayment', payment)
            console.log('*[OK]', res)
            if (this.cart.items) {
              const item_et = []
              const item_list_id = uuidv4()
              let variant = ''
              this.cart.items.forEach((p) => {
                if (p['filters']) {
                  if (p['filters'][0]['color']) {
                    variant = p['filters'][0]['color']
                  }
                  if (variant && p['filters'][0]['memory']) {
                    variant = variant + ' ' + p['filters'][0]['memory']
                  }
                }
                item_et.push({
                  item_name: p['name'],
                  item_id: p['did'],
                  price: p['price'],
                  currency: 'UAH',
                  item_brand: 'Apple',
                  item_category: this.categoryName(p),
                  item_list_name: 'Cart list',
                  item_list_id,
                  quantity: p['qty'],
                })
              })
              //console.log(item_et)
              // this.$gtag.event('complete', {
              //   event_category: 'checkout',
              //   event_label: 'Buy',
              // })
              this.$h.gtmDataLayerPush({
                ecomm_pagetype: 'purchase',
                ecomm_prodid: this.cart.items.map(({ did }) => did),
                ecomm_totalvalue: this.cart.items.reduce(
                  (sum, { price }) => sum + price,
                  0
                ),
              })
              this.$gtag.event('purchase', {
                transaction_id: this.orderId,
                value: this.totalPriceWithFee,
                currency: 'UAH',
                items: item_et,
                email: order.email,
                phone: order.phone,
              })
              this.$gtag.event('gtm.historyChange-v2', {
                email: order.email,
                phone: order.phone,
              })
            }
            const method = `${this.paymentMethod}`.toLowerCase()
            // console.log(method)
            if (
              method === 'cash' ||
              method === 'cash_np' ||
              method === 'cash_adr' ||
              method === 'card'
            ) {
              // this.deliveryMethod = null
              this.unsetDelivery()
              this.$store.commit('resetCart')
              this.showCheckout = false
              this.sent = true
              this.$router.push(`/checkout/order-received/${this.orderId}`)
            } else if (method === 'online') {
              this.openPayment()
            } else if (
              method === 'pb_ii' ||
              method === 'pb_pp' ||
              method === 'pln' ||
              method === 'whitepay'
            ) {
              this.paymentRedirect(method)
            } else if (method === 'mono') {
              //alert(this.partsCount)
              const payload = {
                method,
                order_id: this.orderId,
                phone: this.phoneInternational,
                amount: this.totalPriceWithFee,
                created: new Date(),
                partsCount: this.partsCount,
                products,
              }
              this.$store
                .dispatch('getPaymentStatus', payload)
                .then((res) => {
                  if (res.success) {
                    this.$store.commit('updatePayment', {
                      awaitPageReload: true,
                    })
                    setTimeout(() => {
                      this.$router.push(
                        `/checkout/order-received/${this.orderId}`
                      )
                      this.$store.commit('resetCart')
                      this.showCheckout = false
                      this.deliveryMethod = null
                      this.sent = true
                    }, 1000)
                  } else {
                    // show message
                    this.$store.dispatch(
                      'addNotice',
                      this.$t('paymentMonoRejectMessage')
                    )
                    this.submitting = false
                  }
                })
                .catch((err) => {
                  this.$store.dispatch(
                    'addNotice',
                    this.$t('paymentMonoRejectMessage')
                  )
                  this.submitting = false
                  console.log('*err', err)
                })
            } else if (method === 'globus') {
              const payload = {
                method,
                order_id: this.orderId,
                phone: this.phoneInternational,
                amount: this.totalPriceWithFee,
                created: new Date(),
                partsCount: this.partsCount,
                products,
              }
              this.$store
                .dispatch('getPaymentStatus', payload)
                .then((res) => {
                  console.log('getPaymentStatus res', res)
                  if (res.success) {
                    this.$store.commit('updatePayment', {
                      awaitPageReload: true,
                    })
                    setTimeout(() => {
                      this.$router.push(
                        `/checkout/order-received/${this.orderId}`
                      )
                      this.$store.commit('resetCart')
                      this.showCheckout = false
                      this.deliveryMethod = null
                      this.sent = true
                    }, 1000)
                  } else {
                    // show message
                    this.$store.dispatch(
                      'addNotice',
                      this.$t('paymentMonoRejectMessage')
                    )
                    this.submitting = false
                  }
                })
                .catch((err) => {
                  this.$store.dispatch(
                    'addNotice',
                    err?.response?.data?.error?.message ||
                      this.$t('paymentGlobusRejectMessage')
                  )
                  this.submitting = false
                  console.log('getPaymentStatus *err', err)
                })
            } else if (method === 'abank' || method === 'abank2') {
              //alert(this.partsCount)
              const payload = {
                method,
                order_id: this.orderId,
                phone: this.phoneInternational,
                amount: this.totalPriceWithFee,
                created: new Date(),
                partsCount: this.partsCount,
                products,
              }
              this.$store
                .dispatch('getPaymentStatus', payload)
                .then((res) => {
                  if (res.success) {
                    this.$store.commit('updatePayment', {
                      awaitPageReload: true,
                    })
                    setTimeout(() => {
                      this.$router.push(
                        `/checkout/order-received/${this.orderId}`
                      )
                      this.$store.commit('resetCart')
                      this.showCheckout = false
                      this.deliveryMethod = null
                      this.sent = true
                    }, 1000)
                  } else {
                    // show message
                    this.$store.dispatch(
                      'addNotice',
                      this.$t('paymentABankRejectMessage')
                    )
                    this.submitting = false
                  }
                })
                .catch((err) => {
                  this.$store.dispatch(
                    'addNotice',
                    this.$t('paymentABankRejectMessage')
                  )
                  this.submitting = false
                  console.log('*err', err)
                })
            } else if (method === 'vmc') {
              this.$router.push('/thankyou')
            } else {
              this.$router.push(`/checkout/order-received/${this.orderId}`)
              this.$store.commit('resetCart')
              this.showCheckout = false
              this.deliveryMethod = null
              this.sent = true
            }
          } catch (e) {
            console.log('this.submitOrder', e)
          }
        })
        .catch((e) => {
          console.log('*[FAIL]', e)
        })
    },
    unsetDelivery() {
      this.deliveryMethod = 'pickup'
    },
    onChangeDelivery(s) {
      this.setDeliveryMethod(s ? 'NP' : 'pickup')
      this.showDeliveryCity = s
      if (!s) {
        this.showDeliveryDepartment = false
        this.paymentMethod = 'Cash'
      }
      this.addShippingInfoGtag()
    },
    onChangeName() {
      this.setDeliveryName(this.form.name)
    },
    onTypeCity: debounce(function () {
      if (this.deliveryCity) {
        this.fetchDeliveryCity(this.deliveryCity)
          .then(() => {
            this.showDeliveryCityDropdown = true
          })
          .catch(() => {
            this.showDeliveryDepartment = true
            this.showDeliveryCityDropdown = false
          })
      } else {
        this.showDeliveryCityDropdown = false
      }
    }, 1000),
    onTypeDepartment: debounce(function () {
      /* if (this.showDeliveryDepartmentDropdown && this.deliveryDepartment) {
          this.showDeliveryDepartmentDropdown = false
          setTimeout(() => {
            this.showDeliveryDepartmentDropdown = true
          }, 400)
        } */
    }, 1000),
    onDeliveryCitySelected(id) {
      // console.log('*[city]', id)
      const cty = this.$store.state.delivery.cityRefs.find((v) => v.Ref === id)
      if (cty) {
        this.deliveryCity =
          this.$i18n.locale === 'ru' ? cty.DescriptionRu : cty.Description
      }
      this.setDeliveryCity(id)
      this.showDeliveryCityDropdown = false
      this.showDeliveryDepartment = true
      this.fetchDeliveryDepartment(id)
        .then(() => {
          this.showDeliveryDepartmentDropdown = true
        })
        .catch(() => {
          this.showDeliveryDepartmentDropdown = false
        })
    },
    onDeliveryDepartmentSelected(id) {
      // console.log('*[warehouse]', id)
      const dep = this.$store.state.delivery.departmentRefs.find(
        (v) => v.Ref === id
      )
      if (dep) {
        this.deliveryDepartment =
          this.$i18n.locale === 'ru' ? dep.DescriptionRu : dep.Description
      }
      this.setDeliveryDepartment(id)
      this.showDeliveryDepartmentDropdown = false
    },
    openPayment() {
      const _this = this
      this.showCheckout = false
      const descriptionFromProductsArr = this.cart.items.map((v) => {
        return `${v.name} x ${v.qty}.`
      })
      const description = descriptionFromProductsArr.join(' ')
      const Options = {
        options: {
          methods: ['card'],
          cardIcons: ['mastercard', 'visa'],
          fields: false,
          // title: this.$t('orderPayment'),
          link: 'https://apptown.com.ua',
          fullScreen: false,
          button: true,
          locales: ['ru', 'uk', 'en'],
          email: false,
          tooltip: true,
          fee: true,
        },
        params: {
          // merchant_id: this.$h.env('VUE_APP_FONDY_MERCHANT_ID', '00000'),
          merchant_id: 1426655,
          required_rectoken: 'y',
          currency: 'UAH',
          // обязательно нужно цену множить на 100
          amount: (this.totalPriceWithFee + this.deliveryPayment) * 100,
          order_desc: description,
          lang: this.$i18n.locale === 'ua' ? 'uk' : this.$i18n.locale,
        },
        messages: {
          ru: {
            card_number: 'Номер карты',
            my_title: 'Назначение платежа',
            pay: 'Оплатить',
          },
          uk: {
            card_number: 'Номер картки',
            my_title: 'Призначення платежу',
            pay: 'Оплатити',
          },
          /*en: {
              card_number: 'Card number',
              my_title: 'Order description',
              pay: 'Pay now',
            },*/
        },
      }
      const status = 'approved'
      window
        .fondy('#fondy', Options)
        .$on('success', (model) => {
          const order_status = model.attr('order.order_data.order_status')
          const order_id = model.attr('order.order_data.order_id')
          const sender_email = model.attr('order.order_data.sender_email')
          const masked_card = model.attr('order.order_data.masked_card')
          console.log(
            '*[ORDER SUCCESS]',
            order_status,
            order_id,
            sender_email,
            masked_card
          )
          if (order_status === status) {
            this.$store
              .dispatch('completeOrder', {
                status,
                id: order_id,
                order_id: this.orderId,
              })
              .then(() => {
                setTimeout(() => {
                  this.$router.push(`/checkout/order-received/${this.orderId}`)
                  this.showCheckout = false
                  this.$store.commit('resetCart')
                  this.deliveryMethod = null
                  this.sent = true
                }, 2000)
              })
              .catch((err) => {
                console.log('*err', err)
              })
          } else {
            this.$store.dispatch('completeOrder', {
              status: order_status,
              id: order_id,
              order_id: this.orderId,
            })
          }
        })
        .$on('error', (model) => {
          this.$store.dispatch('completeOrder', {
            status: 'failed',
            id: model.attr('order.order_data.order_id'),
            order_id: this.orderId,
          })
          // const response_code = model.attr('error.code')
          const response_description = model.attr('error.message')
          _this.paymentError = response_description
          _this.closePayment()
        })
      // console.log('*[FONDY]', app)
    },
    closePayment() {
      this.showCheckout = true
    },
    initPayment() {
      let checkout = document.createElement('script')
      let i18nRU = document.createElement('script')
      let i18nUK = document.createElement('script')
      // let i18nEN = document.createElement('script')
      let styles = document.createElement('link')
      checkout.setAttribute('src', 'https://pay.fondy.eu/latest/checkout.js')
      i18nRU.setAttribute('src', 'https://pay.fondy.eu/latest/i18n/ru.js')
      i18nUK.setAttribute('src', 'https://pay.fondy.eu/latest/i18n/uk.js')
      // i18nEN.setAttribute('src', 'https://pay.fondy.eu/latest/i18n/en.js')
      styles.setAttribute('href', 'https://pay.fondy.eu/latest/checkout.css')
      styles.setAttribute('rel', 'stylesheet')
      document.head.appendChild(checkout)
      document.head.appendChild(i18nRU)
      document.head.appendChild(i18nUK)
      // document.head.appendChild(i18nEN)
      document.head.appendChild(styles)
    },
    // WORKS ONLY ON REAL DOMAIN
    paymentRedirect(method) {
      const products = []
      this.cart.items.forEach((item) => {
        let warrantyPrice = 0
        console.log(item)
        item.warranty.forEach((w) => {
          const p = w.split(';')
          if (p[2]) warrantyPrice += +p[2]
        })
        //console.log(warrantyPrice)
        console.log(item)
        products.push({
          name: item.name,
          count: item.qty,
          price: Math.round(
            this.productPriceWithFee(item) +
              this.productPriceWithFeePrice(warrantyPrice)
          ),
          priceUsd: this.productPriceUsd(item),
        })
        if (
          Array.isArray(item.profitableKit) &&
          item.profitableKit.length >= 1
        ) {
          let p
          item.profitableKit.forEach((i) => {
            p = this.makeProfitItem(i, item.qty, item.kitDisc)
            products.push({
              name: p.name,
              count: item.qty,
              kitDisc: item.kitDisc,
              price: Math.round(this.productPriceWithFee(p)),
              priceUsd: p.priceUsd,
            })
          })
          // let p = this.makeProfitItem(
          //   item.profitableKit[0],
          //   item.qty,
          //   item.kitDisc
          // )
          // products.push({
          //   name: p.name,
          //   count: item.qty,
          //   kitDisc: item.kitDisc,
          //   price: Math.round(this.productPriceWithFee(p)),
          //   priceUsd: p.priceUsd,
          // })
          // p = this.makeProfitItem(item.profitableKit[1], item.qty, item.kitDisc)
          // products.push({
          //   name: p.name,
          //   count: item.qty,
          //   kitDisc: item.kitDisc,
          //   price: Math.round(this.productPriceWithFee(p)),
          //   priceUsd: p.priceUsd,
          // })
        }
      })
      const order = {
        method,
        partsCount: this.partsCount,
        order_id: this.$store.state.order.order.order_id,
        amount: this.totalPriceWithFee,
        products,
      }
      const payload = {
        method,
        order,
      }

      if (method === 'pln') {
        payload.order = CryptoJS.AES.encrypt(
          JSON.stringify(order),
          process.env.VUE_APP_CRYPTO
        ).toString()
        // console.log('[paymentRedirect] pln', 'paymentRedirect', payload)
        this.$store
          .dispatch('getPaymentSubmitUrl', payload)
          .then((data) => {
            // console.log('[paymentRedirect] pln', 'getPaymentSubmitUrl', data)
            // submitForm: {
            //   payment: '',
            //   key: '',
            //   url: '',
            //   data: '',
            //   req_token: '',
            //   sign: '',
            //   order: ''
            // },

            this.submitForm.payment = data.payment
            this.submitForm.key = data.key
            this.submitForm.url = data.url
            this.submitForm.data = data.data
            this.submitForm.req_token = data.req_token
            this.submitForm.sign = data.sign
            this.submitForm.order = data.order
            this.$store.commit('resetCart')
            this.showCheckout = false
            this.deliveryMethod = null
            this.sent = true
            setTimeout(() => {
              document.querySelector('#form_submit').submit()
            })
          })
          .catch((err) => {
            console.log('err from component!!!')
            console.log('*err', err)
          })
      } else {
        console.log(`[paymentRedirect] ${payload.method}`, payload)
        this.$store
          .dispatch('getPaymentRedirectUrl', payload)
          .then((url) => {
            console.log(url)
            this.$store.commit('resetCart')
            this.showCheckout = false
            this.deliveryMethod = null
            this.sent = true
            this.$router.push('/redirecting')
            window.location.href = url
          })
          .catch((err) => {
            console.log('err from component!!!')
            console.log('*err', err)
            if (err?.data?.response?.body?.message || err.message) {
              alert(err?.data?.response?.body?.message || err.message)
            }
          })
      }
    },

    cardTransfer(method) {
      const products = []
      this.cart.items.forEach((item) => {
        let warrantyPrice = 0
        console.log(item)
        item.warranty.forEach((w) => {
          const p = w.split(';')
          if (p[2]) warrantyPrice += +p[2]
        })
        //console.log(warrantyPrice)
        products.push({
          name: item.name,
          count: item.qty,
          price: Math.round(
            this.productPriceWithFee(item) +
              this.productPriceWithFeePrice(warrantyPrice)
          ),
          priceUsd: this.productPriceUsd(item),
        })
        if (
          Array.isArray(item.profitableKit) &&
          item.profitableKit.length >= 1
        ) {
          let p
          item.profitableKit.forEach((i) => {
            p = this.makeProfitItem(i, item.qty, item.kitDisc)
            products.push({
              name: p.name,
              count: item.qty,
              kitDisc: item.kitDisc,
              price: Math.round(this.productPriceWithFee(p)),
              priceUsd: p.priceUsd,
            })
          })
          // let p = this.makeProfitItem(
          //   item.profitableKit[0],
          //   item.qty,
          //   item.kitDisc
          // )
          // products.push({
          //   name: p.name,
          //   count: item.qty,
          //   kitDisc: item.kitDisc,
          //   price: Math.round(this.productPriceWithFee(p)),
          //   priceUsd: p.priceUsd,
          // })
          // p = this.makeProfitItem(item.profitableKit[1], item.qty, item.kitDisc)
          // products.push({
          //   name: p.name,
          //   count: item.qty,
          //   kitDisc: item.kitDisc,
          //   price: Math.round(this.productPriceWithFee(p)),
          //   priceUsd: p.priceUsd,
          // })
        }
      })
      const payload = {
        method,
        order: {
          method,
          partsCount: this.partsCount,
          order_id: this.$store.state.order.order.order_id,
          amount: this.totalPriceWithFee,
          products,
        },
      }

      this.$store
        .dispatch('getPaymentTransfer', payload)
        .then((data) => {
          console.log(data)
          this.$router.push('/thankyou')
        })
        .catch((err) => {
          console.log('err from component!!!')
          console.log('*err', err)
        })
    },

    updatePhone({ formatInternational }) {
      this.phoneInternational = formatInternational
      this.setDeliveryPhone(formatInternational)
    },
    preparePhone(p) {
      const x = p
        .replace(/\D/g, '')
        .match(/(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/)

      return !x[2]
        ? x[1]
        : '(' +
            x[1] +
            ') ' +
            x[2] +
            (x[3] ? '-' + x[3] : '') +
            (x[4] ? '-' + x[4] : '')
    },
    phoneMask() {
      this.form.phone = this.preparePhone(this.form.phone)
      this.$v.form.phone.$touch()
    },
    ...mapActions([
      'setHeadline',
      'fetchDeliveryCity',
      'fetchDeliveryDepartment',
      'submitOrder',
    ]),
    ...mapMutations([
      'setDeliveryMethod',
      'setDeliveryCity',
      'setDeliveryDepartment',
      'setDeliveryPhone',
      'setDeliveryName',
      'addWarranty',
    ]),
    addShippingInfoGtag(items) {
      if (!items) {
        const item_list_id = uuidv4()
        items = this.cart.items.map((item) => ({
          item_name: item['name'],
          item_id: item['did'],
          price: item['price'],
          currency: 'UAH',
          item_brand: 'Apple',
          item_category: this.categoryName(item),
          item_list_name: 'Cart list',
          item_list_id,
          quantity: item['qty'],
        }))
      }
      this.$gtag.event('add_shipping_info', {
        shipping_tier: this.deliveryMethod,
        items,
      })
    },
    addPaymentInfoGtag(items) {
      if (!items) {
        const item_list_id = uuidv4()
        items = this.cart.items.map((item) => ({
          item_name: item['name'],
          item_id: item['did'],
          price: item['price'],
          currency: 'UAH',
          item_brand: 'Apple',
          item_category: this.categoryName(item),
          item_list_name: 'Cart list',
          item_list_id,
          quantity: item['qty'],
        }))
      }
      this.$gtag.event('add_payment_info', {
        payment_type: this.paymentMethod,
        items,
      })
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      phone: {
        required,
        alpha: helpers.regex(
          'alpha',
          /\((\d)(\d)\)\s(\d)(\d)(\d)(-)(\d)(\d)(-)(\d)(\d)/i
        ),
      },
      terms: {
        sameAs: sameAs(() => true),
      },
      email: {
        alpha: helpers.regex(
          'alpha',
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      },
    },
    // deliveryCity: {
    //   required,
    // },
  },
  beforeMount() {
    this.setHeadline(this.$t('title.checkout'))
    if (this.$store.getters.payment && this.$store.getters.payment.method) {
      this.paymentMethod = this.$store.getters.payment.method
    }
    if (this.$store.state.delivery && this.$store.state.delivery.phone) {
      const deliveryPhone = this.$store.state.delivery.phone
      const phoneChain = deliveryPhone.split(' ')
      phoneChain.shift()
      const preparedPhone = phoneChain.join('')
      const p = this.preparePhone(preparedPhone)
      this.form.phone = p
    }
    if (this.$store.state.delivery && this.$store.state.delivery.userName) {
      this.form.name = this.$store.state.delivery.userName
    }
    // if (this.$store.getters.delivery && this.$store.getters.delivery.method) {
    //   this.deliveryMethod = this.$store.getters.delivery.method
    // }
    this.$store.dispatch('setBreadcrumbs', [
      { name: this.$t('title.checkout') },
    ])
    this.initPayment()

    this.lang = this.$store.getters.lang
  },
  mounted() {
    this.paymentMethod = this.$route.query.paymentMethod || 'Pln'
    this.partsCount = parseInt(this.$route.query.partsCount) || 3
    //console.log(this.cart)
    if (this.cart.items) {
      const item_et = []
      let variant = ''
      const item_list_id = uuidv4()
      this.cart.items.forEach((p) => {
        if (p['filters']) {
          if (p['filters'][0]['color']) {
            variant = p['filters'][0]['color']
          }
          if (variant && p['filters'][0]['memory']) {
            variant = variant + ' ' + p['filters'][0]['memory']
          }
        }
        item_et.push({
          item_name: p['name'],
          item_id: p['did'],
          price: p['price'],
          currency: 'UAH',
          item_brand: 'Apple',
          item_category: this.categoryName(p),
          item_list_name: 'Cart list',
          item_list_id,
          quantity: p['qty'],
        })
      })
      this.$h.gtmDataLayerPush({
        ecomm_pagetype: 'begin checkout',
        ecomm_prodid: this.cart.items.map(({ did }) => did),
        ecomm_totalvalue: this.cart.items.reduce(
          (sum, item) => sum + this.productPrice(item),
          0
        ),
      })
      this.$gtag.event('begin_checkout', {
        items: item_et,
      })
      this.addShippingInfoGtag(item_et)
      this.addPaymentInfoGtag(item_et)
    }
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
  watch: {
    paymentMethod() {
      this.addPaymentInfoGtag()
    },
    // 'form.address': function(value) {
    //   console.log('*todo: query api for delivery service', value)
    //   if (value && !this.deliveryTargetVisible) {
    //     this.deliveryTargetVisible = true
    //     this.$refs.deliveryTargetContainer.style.display = 'block'
    //   }
    // },
  },
}
</script>

<style>
#delivery {
  overflow: visible;
}
.col2-comments {
  padding-top: 45px;
}
@media only screen and (max-width: 768px) {
  .col2-comments {
    padding-top: 0;
  }
}

#f select.f-input-sm {
  line-height: 20px !important;
}

.tooltip-text {
  font-size: 16px;
  visibility: hidden;
  width: 100%;
  background-color: black;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50px;
  margin-left: -60px;
}
.tooltip-wrap:hover + .tooltip-text {
  visibility: visible;
}
.slonCredit-iframe-wrapper {
  height: 400px;
}
#order_comments {
  min-height: 226px;
}
#billing_phone .select-country-container {
  margin-right: 10px;
}
#billing_phone .country-selector__list {
  height: 100px !important;
}
#billing_phone .input-tel__input {
  border-radius: 10px !important;
}
#billing_phone .country-selector__list__item:hover {
  background: #ddd;
}
#billing_phone .input-tel__label,
#billing_phone .country-selector__label,
#billing_phone .country-selector__country-flag {
  display: none;
}
.woocommerce-input-wrapper .error,
.terms-error {
  color: red;
}
.woocommerce-billing-fields {
  padding: 0 1.3%;
}
</style>
